import { useTranslation } from 'react-i18next';
import LegalDocumentPage from '@/components/legal/LegalDocumentPage';
import { PRIVACY_SECTIONS } from '@/lib/legal/documentSections';
import { resolveLegalLocale } from '@/lib/legal/resolveLegalLocale';
import privacyEn from '@/data/privacy-policy.en.md?raw';
import privacyPt from '@/data/privacy-policy.md?raw';

const PRIVACY_MARKDOWN = {
  pt: privacyPt,
  en: privacyEn,
} as const;

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const locale = resolveLegalLocale(i18n.language);

  return (
    <LegalDocumentPage
      title={t('legalPage.privacy.title')}
      subtitle={t('legalPage.privacy.subtitle')}
      updatedAt="27/10/2026"
      sections={PRIVACY_SECTIONS[locale]}
      markdownContent={PRIVACY_MARKDOWN[locale]}
      companion={{ to: '/terms', label: t('legalPage.terms.title') }}
    />
  );
};

export default PrivacyPolicy;
